<template>
  <TableSpinner :loading="reportLoading">
    <p :class="$style.dateString"> Отчетный период c <b>{{ fromDate }}</b> по <b>{{ toDate }}</b></p>
    <p :class="$style.totalAuthsString"> За указанный период произведено авторизаций: <b>{{totalAuths ? totalAuths : 0}}</b></p>
  
    <h4 >Типы авторизации</h4>
    <el-table :data="statData"  :class="$style.table" >
      <el-table-column prop="type" label="Тип" />
      <el-table-column prop="count" label="Абсолютно" min-width="120" />
      <el-table-column prop="relative" label="Относительно" :formatter="row => row.relative + ' %'" min-width="150"/>
    </el-table>
  </TableSpinner>
</template>

<script>
export default {
  name: "StatisticsTable",
  props: ["fromDate", "toDate", "totalAuths", "statData", "reportLoading"]
}
</script>

<style lang="css" module>
.dateString{
  margin-bottom: 3px;
}

.totalAuthsString{
  margin-top: 0px;
  margin-bottom: 60px;
}

.table{
  width: 100%;
  margin-bottom: 60px;
}
</style>